function traverseUpTo(el, selector) {
  if (el === null || el.matches(selector)) {
    return el;
  }
  return traverseUpTo(el.parentElement, selector);
}

export function generatePreventer(scrollableElementSelector) {
  return function preventDocumentScroll() {
    let originalY;

    function onTouchStart(event) {
      originalY = event.changedTouches[0].clientY;
    }

    function onTouchMove(event) {
      if (!event.cancelable) {
        return;
      }

      const el = traverseUpTo(event.target, scrollableElementSelector);

      // Attempting to scroll an element that should just not ever be scrolled.
      if (el === null) {
        return event.preventDefault();
      }

      const thisY = event.changedTouches[0].clientY;

      // At the top and attempting to scroll up.
      if (el.scrollTop === el.clientTop && originalY < thisY) {
        return event.preventDefault();
      }

      // At the bottom and attempting to scroll down.
      if (el.scrollTop + el.clientHeight === el.scrollHeight && originalY > thisY) {
        return event.preventDefault();
      }
    }

    document.scrollingElement.addEventListener('touchstart', onTouchStart);
    document.scrollingElement.addEventListener('touchmove', onTouchMove, {passive: false});

    return function cleanupDocumentScrollPrevention() {
      document.scrollingElement.removeEventListener('touchstart', onTouchStart);
      document.scrollingElement.removeEventListener('touchmove', onTouchMove);
    };
  };
}
